import React from 'react';
import HeaderRec from '../header/headerRec';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Recruteur = () => {
  const navigate = useNavigate();
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/'); 
    }
  }, [navigate]);
  
  return (
    <div className="recruteur-page">
       <HeaderRec recruteurName={recruteurName} authToken={authToken}  userId={userId} />
    </div>
  );
};

export default Recruteur;
